export const socketData = {
  sid: 'HlYLCfdHtQJqrBJwAAAZ',
  upgrades: ['websocket'],
  pingInterval: 25000,
  pingTimeout: 5000,
};
